import React from 'react';

import ApplicationBadge from '../../../ApplicationBadge';

export default function HiringSubStatus({ row }) {
  return (
    <td>
      <ApplicationBadge jobApplication={row} />
    </td>
  );
}
